export const inviteCoupons = `
  query {
    customersInviteCoupons {
      id
      name
      code
      personalCode
      discountAmount
      discountRatio
      limitCount
      sDate
      eDate
    }
  }
`;
